import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import {Helmet} from "react-helmet";
import { Elements } from 'react-stripe-elements';
import Responsive from 'react-responsive';

import GiftValue from '../../components/gift/GiftValue';
import GiftPayment from './GiftPayment';

import './Gift.css';
import Api from '../../utils/api';

const valueArr = [20, 40, 50, 60, 80, 150];
// const variantArr = [21157100879950, 21157100912718, 21157100945486, 21157100978254, 21170767429710, 21170767659086];

class Gift extends Component {
	constructor() {
		super();

		this.state = {
			toFirstName: '',
			toLastName: '',
			toEmail: '',
			fromName: '',
			fromEmail: '',
			message: '',
			value: 0,
			isExistingUser: false,
			giftStep: 1,
			errorMessageShow: false,
			errorMessage: ""
		};

		this.handleChange = this.handleChange.bind(this);
		this.addGiftUsersToZapierTriggerHook = this.addGiftUsersToZapierTriggerHook.bind(this);
		this.changeGiftValueIndex = this.changeGiftValueIndex.bind(this);
		this.checkIfAccountExists = this.checkIfAccountExists.bind(this);
		this.handleSteps = this.handleSteps.bind(this);
		this.handleStepsBack = this.handleStepsBack.bind(this);
	}

	handleSteps(e) {
		e.preventDefault();
		const { toFirstName, toLastName, toEmail, fromName, fromEmail } = this.state;
		if (!(toFirstName && toLastName && toEmail && fromName && fromEmail)) {
			this.setState({ errorMessageShow: true, errorMessage: "Please fill out all the forms." });
		} else {
			this.setState({ errorMessageShow: false, errorMessage: "" });
			if (this.state.giftStep === 1) {
				let giftStep = this.state.giftStep;
				giftStep++;
				this.setState({ giftStep: giftStep });
				this.checkIfAccountExists();
			}
		}
	}

	handleStepsBack() {
		let giftStep = this.state.giftStep;
		giftStep--;
		this.setState({ giftStep: giftStep });
	}

	/*** CHECKOUT FLOW ***/
	checkIfAccountExists() {	
		const email = this.state.toEmail;
		fetch('/api/account/status?email=' + email)
		.then(response => response.text())
		.then(status => {
            this.setState({ isExistingUser: status === 'true' });
        });
	}


	addGiftUsersToZapierTriggerHook(firstName, lastName, senderName, recipientEmail, senderEmail, message, value, callback) {
		const url = this.state.isExistingUser ? 'https://hooks.zapier.com/hooks/catch/2569749/cec5lq/' : 'https://hooks.zapier.com/hooks/catch/2569749/cwzlsn/';
        fetch(url, {
			method: 'POST',
			headers: {
				Accept: "application/json",
			},
            body: JSON.stringify({
                "fields": {
                    "Recipient First Name": this.state.toFirstName,
                    "Recipient Last Name": this.state.toLastName,
                    "Sender Name": this.state.fromName,
                    "Recipient Email": this.state.toEmail,
                    "Sender Email": this.state.fromEmail,
                    "Message": this.state.message,
                    "Value": valueArr[this.state.value]
                }
			})
        })
        .then(response => {
        	if (response.status >= 200 && response.status < 300) {
					localStorage.setItem("recipient_name", this.state.toFirstName);
							this.props.history.push({
								pathname: '/gift/thank-you'
					});
        	}
        })
        .catch((err) => {
        	alert("Error saving gift card data: " + err);
        });;
    }
    /*** END CHECKOUT FLOW ***/

    handleChange(e) {
    	e.preventDefault();
    	this.setState({ [e.target.name]: e.target.value });
    }

    changeGiftValueIndex(ind) {
    	this.setState({ value: ind });
    }

    renderGiftValues() {
    	const giftValueArr = valueArr.map((value, ind) => {
    		return <GiftValue selectedValueInd={ this.state.value } index={ ind } value={ value } changeGiftValueIndex={ this.changeGiftValueIndex } />
    	});
    	return(
    		<div className="gift-values">
    			{ giftValueArr }
    		</div>
    	);
    }

   

	render() {
		return (
			<div className="gift">
				<Helmet>
                    <title>Give a Gift, Share the Love - HelloAva</title>
                    <meta name="description" content="Want to send beautifully wrapped skin care products to loved ones and friends tailored to their skin needs? Let us do the work." />
                </Helmet>
				<div className="gift-body">
						<div className="gift-section section-one">
		
							{
								this.state.giftStep === 1 ?
								<form id="gift-form">
									<div className="gift-form-step-1">
										<div className="section-1-section recipient-section">
											<h3>TO</h3>
											<label className="gift-label recipient-first-name">
												<h4>First Name</h4>
												<input onChange={ this.handleChange } name="toFirstName" value={ this.state.toFirstName } placeholder="Recipient's first name" />
											</label>
											<label className="gift-label recipient-last-name">
												<h4>Last Name</h4>
												<input onChange={ this.handleChange } name="toLastName" value={ this.state.toLastName } placeholder="Recipient's last name" />
											</label>
											<label className="gift-label recipient-email">
												<h4>Email</h4>
												<input onChange={ this.handleChange } name="toEmail" value={ this.state.toEmail } placeholder="Recipient's email" />
											</label>
										</div>
										<div className="section-1-section sender-section">
											<h3>FROM</h3>
											<label className="gift-label sender-name">
												<h4>What is your name?</h4>
												<input onChange={ this.handleChange } name="fromName" value={ this.state.fromName } placeholder="Your name" />
											</label>
											<label className="gift-label sender-last-name">
												<h4>What is your email?</h4>
												<input onChange={ this.handleChange } name="fromEmail" value={ this.state.fromEmail } placeholder="Your email" />
											</label>
										</div>
										<div className="section-1-section personalize-section">
											<h3>PERSONALIZE YOUR GIFT</h3>
											<label className="gift-label sender-name">
												<h4>Your message</h4>
												<input onChange={ this.handleChange } name="message" value={ this.state.message } placeholder="Type your message here" />
											</label>
										</div>
										<div className="section-1-section gift-section">
											<h3>GIFT VALUE</h3>
											<label className="gift-label sender-name">
												<h4>How much (in USD) would you like to gift?</h4>
												{ this.renderGiftValues() }
											</label>
										</div>
										<div className="section-1-section checkout">
											<button onClick={ this.handleSteps } >Next</button>
										</div>
									</div>
								</form> : 
								<Elements>
									<GiftPayment
										handleStepsBack={ this.handleStepsBack }
										checkIfAccountExists={ this.checkIfAccountExists }
										addGiftUsersToZapierTriggerHook={ this.addGiftUsersToZapierTriggerHook }
										price={ valueArr[this.state.value].toString() + ".00" }
									/>
								</Elements>
							}
								
							
								<Elements>
									<GiftPayment
										handleStepsBack={ this.handleStepsBack }
										checkIfAccountExists={ this.checkIfAccountExists }
										addGiftUsersToZapierTriggerHook={ this.addGiftUsersToZapierTriggerHook }
										price={ valueArr[this.state.value].toString() + ".00" }
									/>
								</Elements>
						</div>
						
						<div className="gift-section section-two">
							<div className="section-two-image">
								{
									<Responsive minWidth={ 768 }>
										<div className="dynamic-name-wrapper">
											<div className="dynamic-name">{ this.state.toFirstName.length <= 10 ? this.state.toFirstName : this.state.toFirstName.substring(0, 10) + "..." }</div>
										</div>
									</Responsive>
								}
								<img src="/images/gift/box.png" alt="Gifting with HelloAva" />
							</div>
							<div className="section-two-header">
								<h2>Not just a gift card. An experience</h2>
								<p>For anyone, for any occasion—the possibilities are endless with the gift of personal touch.</p>
							</div>
							<div className="what-will-they-get">
								<h2>What will they get?</h2>
								<div className="what-will-they-get-blocks">
									<div className="what-will-they-get-block">
										<div className="what-will-they-get-img">
											<img src="/images/gift/check.png" alt="check" />
										</div>
										<p><span>Skincare products</span> that are curated for their needs and skin type</p>
									</div>
									<div className="what-will-they-get-block">
										<div className="what-will-they-get-img">
											<img src="/images/gift/check.png" alt="check" />
										</div>
										<p>A <span>personalized regimen card</span> that tells them the step-by-step</p>
									</div>
								</div>
							</div>
						</div>
					
				</div>
			</div>
		);
	}
}

export default withRouter(Gift);



// WEBPACK FOOTER //
// ./src/views/gift/Gift.js